type ProductWithGroupCode = {
  groupCode?: string | number;
  masterProductId?: string | number;
};

type MasterProductGroupCodeObject = {
  groupCode: string;
  masterProductIds: Array<string | number | undefined>;
};

/**
 * Dedupe products by groupCode, merging masterProductIds under each group.
 * groupCode is normalised to string because the API sometimes returns numbers.
 */
export function buildMasterProductGroupCodeObjects(
  products: ProductWithGroupCode[]
): MasterProductGroupCodeObject[] {
  const groupCodeMap = new Map<string, MasterProductGroupCodeObject>();
  for (const result of products) {
    const key = String(result?.groupCode);
    if (groupCodeMap.has(key)) {
      groupCodeMap.get(key)!.masterProductIds.push(result?.masterProductId);
    } else {
      groupCodeMap.set(key, {
        groupCode: key,
        masterProductIds: [result?.masterProductId],
      });
    }
  }
  return Array.from(groupCodeMap.values());
}
